import React from "react";
import { MCheckbox, MInput, ValidatedForm } from "components/forms";
import { payloadBuilder } from "libs";

export class VincitoreConcorso extends ValidatedForm {

  emptyFields = {
    istitution: "",
    dataConcorso: "",
    description: "",
    classeConcorso: this.props.competitionClass,
    checkVC01: false,
    checkVC02: false,
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    loading: true,
    ...this.emptyFields,
    validationError: "",
    defaultValues: {
      ...this.emptyFields,
    },
  };

  componentDidUpdate(prevProps) {
    if (prevProps.defaultPayload !== this.props.defaultPayload) {
      if (this.props.defaultPayload) {
        //get first element of the array
        const payload = this.props.defaultPayload[0];

        let newValues = {
          ...this.emptyFields,
          ...payload,
          classeConcorso: this.props.competitionClass,
        };

        // if fields not empty, checkVC = true
        /*
        if (!newValues.checkVC01) {
          const { istitution, dataConcorso, description } = newValues;
          if (istitution || dataConcorso || description) {
            newValues.checkVC01 = true;
          }
        }*/

        this.setState({
          ...newValues,
          defaultValues: newValues,
          loading: false,
        });
      }
    }
  }

  FIELDS_GROUP = [
    [
      {
        id: "checkVC001",
        field: "checkVC01",
        component: MCheckbox,
        className: "col-md-12",
        label:
          "Dichiaro di essere vincitore del concorso PNNR1 (D.D.2575/2023), e di aver sottoscritto un contratto di lavoro subordinato a tempo determinato.",
      },
    ],
    [
      {
        id: "checkVC002",
        field: "checkVC02",
        component: MCheckbox,
        className: "col-md-12 mb-5",
        label:
          "Dichiaro di essere vincitore del concorso PNNR2 (D.D. 3059/2024)	 e di aver sottoscritto un contratto di lavoro subordinato a tempo determinato.",
      },
    ],
    [
      {
        id: "istitution01",
        field: "istitution",
        label: "Ufficio Scolastico Regionale (USR) ",
        component: MInput,
        className: "col-md-12",
        infoText: "ufficio della regione che ha bandito il concorso",
      },
    ],
    [
      {
        id: "dataConcorso01",
        field: "dataConcorso",
        label: "Concorso indetto in data",
        component: MInput,
        type: "date",
        className: "col-md-5",
        infoText: "Inserire la data",
      },
      {
        id: "description01",
        field: "description",
        label: "Decreto concorso numero",
        component: MInput,
        className: "col-md-5",
      },
      {
        id: "classeConcorso00",
        field: "classeConcorso",
        label: "Classe di Concorso",
        component: MInput,
        readOnly: true,
        className: "col-md-2",
      },
    ],
  ];

  ERROR_MESSAGES = {
    istitution: "Dato obbligatorio",
    classeConcorso: "Dato obbligatorio",
    dataConcorso: "Data non valida",
    description: "Dato obbligatorio",

  };

  validation = {
    istitution: (value) => value !== "",
    dataConcorso: (value) => this.validateDataConcorso(value),
    classeConcorso: (value) => value !== "",
    description: (value) => value !== "",
    // checkVC01: (value) => this.validateCheck(value),
    // checkVC02: (value) => this.validateCheck(value),
  };
  /*
    validateCheck = (value) => {
      if (value === "" || value === false) {
        return false;
      }
      return true;
    };
  */
  validateDataConcorso = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }

    //--- ---
    // not in the future
    const today = new Date();
    if (date > today) {
      return false;
    }

    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    return true;
  };

  onSubmit = () => {
    let isValid = true;
    isValid = this.checkValidation();
    let validationError = "";
    //const { checkVC01, checkVC02 } = this.state;
    const checkVC01 = this.getValueField("checkVC01");
    const checkVC02 = this.getValueField("checkVC02");

    if (checkVC01 && checkVC02) {
      validationError = "Selezionare SOLAMENTE una delle due opzioni."
      isValid = false;
    } else if (!(checkVC01 || checkVC02)) {
      validationError = "Selezionare UNA delle due opzioni."
      isValid = false;
    }


    this.setState({ validationError });
    return isValid;
  };

  getPayload = () => {
    const payloadOther = [];

    let payload = {};
    const checkVC01 = this.getValueField("checkVC01");
    const checkVC02 = this.getValueField("checkVC02");

    payload = payloadBuilder(this.state);
    payload.qualificationCode = "title15_VINCITORE_CONCORSO";
    payload.qualificationType = "title15";
    payload.template = "Title15_VINCITORE_CONCORSO";
    if (checkVC01)  payload.template = "Title15_VINCITORE_CONCORSO_01";
    if (checkVC02)  payload.template = "Title15_VINCITORE_CONCORSO_02";
    payload.extCode = "CONC";
    payloadOther.push(payload);

    return payloadOther;
  };

  //--- ---

  render() {
    const { defaultValues, validationError } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        {validationError && (
          <div className="text-danger">{validationError}</div>
        )}
        <form className="user mt-4">{code}</form>
      </>
    );
  }
}
